<template>
  <div class="custom-option-selector">
    <div class="custom-option-selector__wrapper">
      <div class="custom-option-selector__content">
        <div
          class="custom-option-selector__content__selected"
          v-if="getSelectedItem(internalValue)"
        >
          <div class="custom-option-selector__content__selected__image">
            <img :src="getSelectedItem(internalValue)?.image || ''" alt="" />
          </div>
          <div class="custom-option-selector__content__selected__title">
            {{ getSelectedItem(internalValue)?.label || '' }}
          </div>
        </div>
        <div
          class="custom-option-selector__content__not-selected clickable"
          @click="openModal"
          v-else
        >
          <div>
            <div class="custom-option-selector__content__not-selected__title">
              Escolha do nosso banco de dados
            </div>
            <div class="custom-option-selector__content__not-selected__icon">
              <font-awesome-icon
                :icon="['fas', 'hand-pointer']"
              ></font-awesome-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-option-selector__actions">
        <div class="option option__add" @click="openModal">
          <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        </div>

        <div
          class="option option__delete"
          v-if="getSelectedItem(internalValue)"
          @click="clearSelection"
        >
          <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </div>
      </div>
    </div>
  </div>

  <Dialog
    v-model:visible="displayModal"
    :style="{ width: '80vw' }"
    :modal="true"
  >
    <div class="modal-content">
      <div class="modal__options">
        <div
          class="modal__options__item"
          v-for="item in options"
          :key="item.value"
          :class="{ selected: isItemSelected(item) }"
          @click="selectItem(item)"
        >
          <div class="modal__options__item__image">
            <img :src="item.image" alt="" />
          </div>
          <div class="modal__options__item__name">{{ item.label }}</div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
  import Dialog from 'primevue/dialog'

  export default {
    components: {
      Dialog,
    },
    emits: ['item-selected-event'],
    props: {
      options: {
        type: Array,
        required: true,
      },
      value: {
        type: String,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        displayModal: false,

        internalValue: null,
      }
    },
    methods: {
      openModal() {
        this.displayModal = true
      },
      closeModal() {
        this.displayModal = false
      },
      isItemSelected(item) {
        return item.value === this.internalValue
      },
      selectItem(item) {
        this.internalValue = item.value
        this.closeModal()
      },
      getSelectedItem(value) {
        return this.options.find((i) => i.value === value)
      },
      clearSelection() {
        this.internalValue = null
      },
    },
    watch: {
      value(newValue) {
        this.internalValue = newValue
      },
      internalValue(newValue) {
        this.$emit('item-selected-event', { selected: newValue })
      },
    },
    mounted() {
      this.internalValue = this.value
    },
  }
</script>

<style lang="scss" scoped>
  .custom-option-selector {
    &__wrapper {
      position: relative;

      border: 1px solid #dee2e6;
      border-radius: 4px;
      min-height: 200px;
    }

    &__content {
      height: 100%;
      width: 100%;

      position: absolute;
      top: 0;
      left: 0;

      &__selected {
        height: 100%;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__image {
          width: 120px;
          max-height: 160px;

          img {
            width: 100%;
            height: auto;
            object-fit: cover;
          }
        }
      }

      &__not-selected {
        height: 100%;
        color: #cacaca;
        font-size: 1.5rem;

        text-align: center;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &__icon {
          font-size: 3rem;
        }
      }
    }

    &__actions {
      position: absolute;

      bottom: 10px;
      right: 10px;
      width: auto;

      display: flex;

      .option {
        $defaultColor: rgb(76, 175, 80);

        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        color: white;

        padding: 5px;
        width: 30px;
        height: 30px;

        border: 2px solid #ccc;
        color: $defaultColor;

        transition: box-shadow 0.5s ease, background-color 0.3s ease;

        &:hover {
          border: none;
          box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

          background-color: $defaultColor;

          color: white;
        }

        &:not(:first-child) {
          margin-left: 5px;
        }

        &__delete {
          color: rgb(244, 67, 54);

          &:hover {
            box-shadow: 1px 2px 8px rgb(0, 0, 0, 0.2);

            background-color: rgb(244, 67, 54);
          }
        }
      }
    }
  }

  .modal {
    &-content {
      border: none;
    }

    &__options {
      display: grid;
      grid-template-columns: auto auto auto auto;
      grid-auto-rows: 160px;
      grid-gap: 20px;
      align-items: stretch;

      &__item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        padding: 10px;

        border: 1px solid #ccc;
        border-radius: 5px;

        transition: box-shadow 0.4s ease, border 0.4s ease;

        cursor: pointer;

        &.selected {
          border: 2px solid rgb(76, 175, 80);
          box-shadow: 0px 0px 10px #ccc;
        }

        &:hover {
          box-shadow: 0px 0px 10px #ccc;
        }

        &__image {
          text-align: center;
          width: 180px;
          height: 100px;

          img {
            max-width: 80%;
            max-height: 100%;
            object-fit: cover;
          }
        }

        &__name {
          font-size: 0.8rem;
        }
      }
    }
  }
</style>
